export default {"src":"/_next/static/media/aig-core-blue.3d691c9f.svg","height":56,"width":112,"blurWidth":0,"blurHeight":0};